import Script from 'next/script'

type Props = {
  nonce?: string
}

export const ApplePayScript = ({ nonce }: Props) => {
  return (
    <Script
      async
      type="text/javascript"
      src="https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js"
      nonce={nonce}
    />
  )
}
